import {DomainObject} from 'shared/store';
import { observable, computed, makeObservable } from 'mobx';
import {PerformanceReviewTemplate} from 'main/stores/performance_reviews';
import {t} from 'shared/core';

class PerformanceReviewType extends DomainObject {
  id;
  kind;
  template;

  _relations = {
    template: PerformanceReviewTemplate
  };

  constructor(other) {
    super();

    makeObservable(this, {
      id: observable,
      kind: observable,
      template: observable,
      displayKind: computed
    });

    this.merge(other);
  }

  get displayKind() {
    return t(`models.performance_reviews.type.${this.kind}`);
  }
}

export default PerformanceReviewType;
